import { Navigate, Outlet } from "react-router-dom";

type PrivateRouteProps = {
  isActive: boolean;
};

export const PrivateRoute = ({ isActive }: PrivateRouteProps) => {
  return isActive ? (
    <Outlet />
  ) : (
    <Navigate
      to="/subscribe"
      replace
    />
  );
};
